module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
// module chunks = styles